export const translations = {
  en: {
    // Navbar
    nav: ['Home', 'Services', 'Why Us', 'Our Team', 'Contact'],
    freeConsultation: 'Free Consultation',
    clients: 'Our Clients', // Added clients key
    // Hero
    trustedBy: 'Trusted by Leading Saudi Enterprises',
    heroTitle: 'Empowering Saudi Visions with ',
    heroHighlight: 'Futuristic Connectivity',
    heroDesc: 'Unlock ultra-reliable, scalable network solutions tailored for the Kingdom\'s ambitious digital future.',
    startProject: 'Start Your Project',
    discoverServices: 'Discover Services',
    // Services
    ourServices: 'Our Premium Services',
    servicesTitle: 'Tailored Solutions for Saudi Excellence',
    servicesDesc: 'Benefit from high-performance networks that drive efficiency and growth in the Kingdom.',
    learnMore: 'Learn More',
    showAllServices: "Show All Services",
    allServices: "All Services",
    allServicesTitle: "Explore All Our Services",
    allServicesDesc: "Discover our complete range of professional services designed to help your business grow and succeed.",
    // Why Us
    whyChoose: 'Why Choose Saturn Lynk',
    whyTitle: 'Your Partner in Saudi Digital Success',
    whyDesc: 'Experience the difference with our commitment to excellence and innovation.',
    points: [
      { title: "Unmatched Security", desc: "Enterprise-level protection aligned with Saudi regulations." },
      { title: "Lightning-Fast Deployment", desc: "Rapid implementation to accelerate your business goals." },
      { title: "24/7 Premium Support", desc: "Dedicated assistance ensuring zero downtime." },
      { title: "Future-Proof Innovation", desc: "AI-integrated systems for long-term growth." }
    ],
    // Stats
    stats: [
      { number: "500+", label: "Projects Delivered" },
      { number: "98%", label: "Satisfaction Rate" },
      { number: "24/7", label: "Support Availability" },
      { number: "15+", label: "Years of Expertise" },
    ],
    // Case Studies
    caseStudies: 'Case Studies',
    caseTitle: 'Proven Success Stories',
    caseDesc: 'See how we\'ve transformed businesses in the Kingdom.',
    viewDetails: 'View Details',
    // Our Team
    ourTeam: 'Our Team',
    teamTitle: 'Meet the People Behind Our Success',
    teamDesc: 'Dedicated leaders shaping the future with innovation, strategy, and purpose.',
    teamMembers: [
      {
        name: "General Manager",
        role: "Message from General Manager",
        message:
          "At Saturn Lynk Technologies, we are committed to delivering reliable, innovative, and efficient IT solutions that meet the evolving needs of our clients. Our focus is on maintaining high-quality standards, ensuring timely delivery, and providing exceptional customer support. We believe in building long-term relationships based on trust, transparency, and excellence. As we continue to grow, our priority remains the same to empower businesses with technology that drives success. Thank you for choosing Saturn Lynk Technologies.",
      },
      {
        name: "Country Sales Manager",
        role: "Message from Country Sales Manager",
        message:
          "At Saturn Lynk Technologies, our goal is to deliver the highest level of value and service to clients across the Kingdom. We strive to understand our customers’ needs and provide tailored IT solutions that support their growth and success. With a strong focus on responsiveness, quality, and long-term partnerships, our sales team is dedicated to ensuring that every client receives exceptional support from the first inquiry to project completion and beyond. We look forward to serving you and helping your business achieve its full potential."
      },
    ],
    // Contact
    getInTouch: 'Get in Touch',
    buildFuture: "Let's Build Your Future",
    contactDesc: 'Contact us for a free consultation or via WhatsApp.',
    phone: '+966 55 125 4121',
    email: 'info@saturnlynk.sa',
    location: 'Jeddah, Saudi Arabia',
    chatWhatsApp: 'Chat on WhatsApp',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    yourPhone: 'Your Phone',
    yourMessage: 'Your Message',
    sendMessage: 'Send Message',
    phoneOptional: '(Optional)',
    messageSent: 'Message sent successfully!',
    quoteSent: 'Quote request sent successfully! We\'ll contact you soon.',
    submissionError: 'An error occurred. Please try again.',
    networkError: 'Network error. Please check your connection and try again.',
    sending: 'Sending...',
    errorNameRequired: 'Name is required.',
    errorEmailRequired: 'Email is required.',
    errorInvalidEmail: 'Please enter a valid email address (e.g., user@example.com).',
    errorInvalidPhone: 'Please enter a valid phone number (e.g., +966 50 123 4567 or 05xxxxxxxx).',
    errorMessageRequired: 'Message is required.',
    errorMessageTooShort: 'Message should be at least 10 characters long.',
    errorServiceRequired: 'Please select a service.',
    errorDetailsTooShort: 'Project details should be at least 10 characters long.',
    // Footer
    footerDesc: "Futuristic connectivity for Saudi's digital era.",
    links: 'Links',
    servicesFooter: 'Services',
    contactFooter: 'Contact',
    networkInfra: 'Network Infrastructure',
    fiberOptics: 'Fiber Optic Solutions',
    copyright: '© 2025 Saturn Lynk. All rights reserved.',
    // Quote Modal
    quoteTitle: 'Free Consultation',
    selectService: 'Select Service',
    projectDetails: 'Project Details',
    submit: 'Submit',
    // Chatbot
    liveSupport: 'Live Support',
    howAssist: 'How can we assist you today?',
    requestQuote: 'Request Quote',
    viewServices: 'View Services',
    chatOnWA: 'Chat on WhatsApp',
    // Clients Page - New Translations
    valuedClients: 'Our Valued Clients',
    clientsSubtitle: 'Trusted by businesses worldwide. Discover what our clients have to say about their experience working with us.',
    clientTestimonials: 'Client Testimonials',
    trustedByLeaders: 'Trusted By Industry Leaders',
    joinFamily: 'Ready to Join Our Family of Happy Clients?',
    joinFamilyDesc: 'Let\'s create something amazing together. Get started with a free consultation today.',
    startProjectToday: 'Start Your Project',
    happyClients: 'Happy Clients',
    satisfactionRate: 'Satisfaction Rate',
    averageRating: 'Average Rating',
    support: 'Support',
    project: 'Project',
    at: 'at',
    // New keys for ServiceDetail
    serviceNotFound: 'Service Not Found',
    serviceOverview: 'Service Overview',
    keyFeatures: 'Key Features',
    benefits: 'Benefits',
    getStarted: 'Get Started',
  },
  ar: {
    // Navbar
    nav: ['الرئيسية', 'الخدمات', 'لماذا نحن', 'فريقنا', 'تواصل معنا'],
    freeConsultation: 'استشارة مجانية',
    clients: 'عملاؤنا', // Added clients key
    // Hero
    trustedBy: 'موثوق به من قبل الشركات السعودية الرائدة',
    heroTitle: 'تمكين الرؤى السعودية بـ ',
    heroHighlight: 'الاتصال المستقبلي',
    heroDesc: 'اكتشف حلول شبكات فائقة الموثوقية وقابلة للتوسع مصممة لرؤية المملكة الطموحة.',
    startProject: 'ابدأ مشروعك',
    discoverServices: 'اكتشف خدماتنا',
    // Services
    ourServices: 'خدماتنا المتميزة',
    servicesTitle: 'حلول مخصصة للتميز السعودي',
    servicesDesc: 'استفد من شبكات عالية الأداء تدفع الكفاءة والنمو في المملكة.',
    learnMore: 'اعرف المزيد',
    showAllServices: "عرض جميع الخدمات",
    allServices: "جميع الخدمات",
    allServicesTitle: "استكشف كل خدماتنا",
    allServicesDesc: "اكتشف مجموعتنا الكاملة من الخدمات الاحترافية المصممة لمساعدة أعمالك على النمو والنجاح.",
    // Why Us
    whyChoose: 'لماذا تختار ساترن لينك',
    whyTitle: 'شريكك في النجاح الرقمي السعودي',
    whyDesc: 'جرب الفرق مع التزامنا بالتميز والابتكار.',
    points: [
      { title: "أمان لا مثيل له", desc: "حماية على مستوى المؤسسات تتماشى مع اللوائح السعودية." },
      { title: "نشر فائق السرعة", desc: "تنفيذ سريع لتسريع أهداف عملك." },
      { title: "دعم متميز 24/7", desc: "مساعدة مخصصة لضمان عدم التوقف." },
      { title: "ابتكار مستقبلي", desc: "أنظمة مدعومة بالذكاء الاصطناعي للنمو طويل الأمد." }
    ],
    // Stats
    stats: [
      { number: "500+", label: "مشاريع تم تسليمها" },
      { number: "98%", label: "معدل الرضا" },
      { number: "24/7", label: "توفر الدعم" },
      { number: "15+", label: "سنوات من الخبرة" },
    ],
    // Case Studies
    caseStudies: 'دراسات الحالة',
    caseTitle: 'قصص نجاح مثبتة',
    caseDesc: 'شاهد كيف غيرنا أعمال الشركات في المملكة.',
    viewDetails: 'عرض التفاصيل',
    // Our Team
    ourTeam: 'فريقنا',
    teamTitle: 'تعرف على الأشخاص وراء نجاحنا',
    teamDesc: 'قادة ملتزمون يشكلون المستقبل بالابتكار والاستراتيجية والغاية.',
    teamMembers: [
      {
        name: "المدير العام",
        role: "رسالة من المدير العام",
        message:
          "في شركة ساترن لينك تكنولوجيز، نحن ملتزمون بتقديم حلول تقنية معلومات موثوقة ومبتكرة وفعالة تلبي احتياجات عملائنا المتطورة. تركيزنا على الحفاظ على معايير الجودة العالية، ضمان التسليم في الوقت المحدد، وتقديم دعم عملاء استثنائي. نحن نؤمن ببناء علاقات طويلة الأمد مبنية على الثقة والشفافية والتميز. مع استمرار نمونا، يظل أولويتنا كما هي: تمكين الأعمال بالتكنولوجيا التي تدفع النجاح. شكراً لاختياركم شركة ساترن لينك تكنولوجيز.",
      },
      {
        name: "مدير المبيعات",
        role: "رسالة من مدير المبيعات",
        message:
          "في شركة ساترن لينك تكنولوجيز، هدفنا هو تقديم أعلى مستوى من القيمة والخدمة لعملائنا عبر المملكة. نسعى لفهم احتياجات عملائنا وتقديم حلول تقنية معلومات مخصصة تدعم نموهم ونجاحهم. مع تركيز قوي على الاستجابة والجودة والشراكات طويلة الأمد، فريق المبيعات لدينا ملتزم بضمان أن يحصل كل عميل على دعم استثنائي من الاستفسار الأول إلى إكمال المشروع وما بعده. نتطلع إلى خدمتكم ومساعدة أعمالكم على تحقيق إمكانياتها الكاملة.",
      },
    ],
    // Contact
    getInTouch: 'تواصل معنا',
    buildFuture: 'لنبني مستقبلك',
    contactDesc: 'تواصل معنا لاستشارة مجانية أو عبر واتساب.',
    phone: '+966 55 125 4121',
    email: 'info@saturnlynk.sa',
    location: 'جدة، المملكة العربية السعودية',
    chatWhatsApp: 'دردشة على واتساب',
    yourName: 'اسمك',
    yourEmail: 'بريدك الإلكتروني',
    yourPhone: 'رقم هاتفك',
    yourMessage: 'رسالتك',
    sendMessage: 'إرسال الرسالة',
    phoneOptional: '(اختياري)',
    messageSent: 'تم إرسال الرسالة بنجاح!',
    quoteSent: 'تم إرسال طلب العرض بنجاح! سنتواصل معك قريباً.',
    submissionError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    networkError: 'خطأ في الشبكة. يرجى التحقق من الاتصال وحاول مرة أخرى.',
    sending: 'جاري الإرسال...',
    errorNameRequired: 'الاسم مطلوب.',
    errorEmailRequired: 'البريد الإلكتروني مطلوب.',
    errorInvalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح (مثال: user@example.com).',
    errorInvalidPhone: 'يرجى إدخال رقم هاتف صالح (مثال: +966 50 123 4567 أو 05xxxxxxxx).',
    errorMessageRequired: 'الرسالة مطلوبة.',
    errorMessageTooShort: 'يجب أن تكون الرسالة 10 أحرف على الأقل.',
    errorServiceRequired: 'يرجى اختيار خدمة.',
    errorDetailsTooShort: 'يجب أن تكون تفاصيل المشروع 10 أحرف على الأقل.',
    // Footer
    footerDesc: 'اتصال مستقبلي لعصر المملكة الرقمي.',
    links: 'روابط',
    servicesFooter: 'الخدمات',
    contactFooter: 'تواصل',
    networkInfra: 'البنية التحتية للشبكات',
    fiberOptics: 'حلول الألياف البصرية',
    copyright: '© 2025 ساترن لينك. جميع الحقوق محفوظة.',
    // Quote Modal
    quoteTitle: 'استشارة مجانية',
    selectService: 'اختر الخدمة',
    projectDetails: 'تفاصيل المشروع',
    submit: 'إرسال',
    // Chatbot
    liveSupport: 'الدعم المباشر',
    howAssist: 'كيف يمكننا مساعدتك اليوم؟',
    requestQuote: 'طلب عرض أسعار',
    viewServices: 'عرض الخدمات',
    chatOnWA: 'الدردشة على واتساب',
    // Clients Page - New Translations
    valuedClients: 'عملاؤنا الكرام',
    clientsSubtitle: 'موثوق به من قبل الشركات حول العالم. اكتشف ما يقوله عملاؤنا عن تجربتهم في العمل معنا.',
    clientTestimonials: 'آراء العملاء',
    trustedByLeaders: 'موثوق به من قبل قادة الصناعة',
    joinFamily: 'مستعد للانضمام إلى عائلتنا من العملاء السعداء؟',
    joinFamilyDesc: 'لنخلق شيئًا مذهلاً معًا. ابدأ باستشارة مجانية اليوم.',
    startProjectToday: 'ابدأ مشروعك',
    happyClients: 'عميل سعيد',
    satisfactionRate: 'معدل الرضا',
    averageRating: 'متوسط التقييم',
    support: 'الدعم',
    project: 'المشروع',
    at: 'في',
    // New keys for ServiceDetail
    serviceNotFound: 'الخدمة غير موجودة',
    serviceOverview: 'نظرة عامة على الخدمة',
    keyFeatures: 'الميزات الرئيسية',
    benefits: 'الفوائد',
    getStarted: 'ابدأ الآن',
  }
};